(function() {
    'use strict';

    angular.module( APP_ID )
        .constant( 'CONFIG', AppConfig() );

    /** App's configuration - contains READ ONLY data (that must not be maniupulated on runtime. */
    function AppConfig(){

        /** Environment-wide configuration options (MUST BE edited in build/config/env/*.js and then rebuilt with `grunt update`). */
        var envConfig = baseConfig.env,
            envType   = baseConfig.envName,

            urls      = envConfig.urls,

            websiteNoProtocol = urls.website.replace( /^https?\:\/\//i, '' ),
            websiteStageNoProtocol = urls.websiteStage.replace( /^https?\:\/\//i, '' ),

        config = {
            VERSION:    baseConfig.version,
            BUILD_TIME: baseConfig.buildTime,
            ENV_TYPE:   envType,
            PROTOCOL: ( envConfig.protocol === 'both' ? 'https' : envConfig.protocol ),
            HOSTNAME: envConfig.hostname,
            BASEPATH: envConfig.basePath,

            IS_DEVELOPMENT_MODE: !baseConfig.productionReady,

            COOKIE_EXPIRATION_IN_DAYS: 90,
            COOKIE_DOMAIN:             'wgtn.ac.nz',

            MODES: {
                // Administrators *ONLY* content
                ADMIN: {
                    MODE_ID:    'admin', // Must match name of parental object (~ 'ADMIN' || 'admin')
                    SUBDOMAIN:  'dev-node',
                    API: {
                        CMS: {
                            PROTOCOL: 'http',
                            BASE_URL: websiteStageNoProtocol + '/api/'
                        }
                    },
                    CMS_BASE_URL: '//' + websiteStageNoProtocol,
                },

                // Stage content for local development
                LOCAL: {
                    MODE_ID:    'local', // Must match name of parental object (~ 'ADMIN' || 'admin')
                    SUBDOMAIN:  'local',
                    API: {
                        CMS: {
                            PROTOCOL: 'https',
                            BASE_URL: websiteNoProtocol + '/api/stage-'
                        }
                    },
                    CMS_BASE_URL: '//' + websiteStageNoProtocol,
                },

                // Stage content
                STAGE: {
                    MODE_ID:    'stage',
                    SUBDOMAIN:  'stage',
                    API: {
                        CMS: {
                            PROTOCOL: 'https',
                            BASE_URL: websiteNoProtocol + '/api/stage-'
                        }
                    },
                    CMS_BASE_URL: '//' + websiteNoProtocol,
                },

                // Public visitors
                PUBLIC: {
                    MODE_ID:    'public',
                    SUBDOMAIN:  'www',
                    API: {
                        CMS: {
                            PROTOCOL: 'https',
                            BASE_URL: websiteNoProtocol + '/api/'
                        }
                    },
                    CMS_BASE_URL: '//' + websiteNoProtocol,
                }
            },

            // External URLS
            URLS: {
                WEBSITE_BASE:       urls.website,
                WEBSITE_STAGE_BASE: urls.websiteStage,
                SHARED_ASSETS:      urls.staticAssets,

                VICTORIA_SEARCH:    urls.website + '/search',
                SITE_FEEDBACK:      urls.website + '/feedback',
            },

            // App's exposed URL paths
            ROUTES: {
                STUDY_AREAS:    'study-areas',
                DEGREES:        'degrees',
                POSTGRAD_AREAS: 'postgraduate-subjects',
                POSTGRADS:      'postgraduate-programmes',
                GRADUATE_QUALS: 'graduate-quals',
                OTHER_QUALS:    'other-quals'
            },

            // Information about Angular's states
            STATES: {
                EXPLORE:    'explore',

                // Top-level page
                STUDY_AREA: 'study-areas',

                // Sub page
                STUDY_AREAS: {
                    // Naming convention is recommended as following: [parent-name]#[subpage-name]
                    ABOUT:  'study-areas#about',
                    STUDY:  'study-areas#study',
                    PEOPLE: 'study-areas#people'
                },

                DEGREE: 'degrees',

                DEGREES: {
                    ABOUT:        'degrees#about',
                    REQUIREMENTS: 'degrees#requirements',
                    APPLY:        'degrees#apply'
                },

                POSTGRAD_AREA:      'postgrad-areas',

                POSTGRAD_AREAS: {
                    ABOUT:          'postgrad-areas#about',
                    QUALIFICATIONS: 'postgrad-areas#qualifications',
                    PEOPLE:         'postgrad-areas#people'
                },

                SPECIALISATION:     'specialisation',

                SPECIALISATIONS: {
                    ABOUT:          'postgrads#about',
                    STUDY:          'postgrads#study',
                    REQUIREMENTS:   'postgrads#requirements',
                    PEOPLE:         'postgrads#people',
                    APPLY:          'postgrads#apply'
                },

                POSTGRAD:           'postgrads',

                POSTGRADS: {
                    ABOUT:          'postgrads#about',
                    STUDY:          'postgrads#study',
                    REQUIREMENTS:   'postgrads#requirements',
                    PEOPLE:         'postgrads#people',
                    APPLY:          'postgrads#apply'
                },

                SERVER_NOT_FOUND:   'server404',
                NOT_FOUND:          '404'
            },

            REDIRECTS: {
                TOPICS_URL: urls.website + '/study/programmes-courses/subjects' /* eslint angular/window-service: 0 */
            },

            // Used parameters
            PARAMS: {
                POSTGRAD_ID:        'postgradId',
                POSTGRAD_AREA_ID:   'postgradAreaId',
                DEGREE_ID:          'degreeId',
                STUDY_AREA_ID:      'studyAreaId',
                QUALIFICATION_ID:   'qualificationId',

                INTERNATIONAL:      'international',
                PRIMARY_MAJOR:      'major',
                SECONDARY_MAJOR:    'otherMajor',
                MODE:               'mode',

                SUBJECT:            'subject',
                PROGRAMME:          'programme',
                SPECIALISATION:     'specialisation',

                // Sub-state
                QUAL_TYPE:          'qualType',
            },

            // '#'-based anchors
            ANCHORS: {
                MAJORS_SELECTION:   'select-majors',
                MAJORS:             'majors',
                ENTRY_REQUIREMENTS: 'entry-requirements'
            },

            // Settings for general analytics and event tracking
            ANALYTICS: {
                GTM_ID: {
                    NOT_FOUND: '404',
                },
                CATEGORY: {
                    KIS: 'KIS',
                },
                EVENT: {
                    KIS_CLICK: 'User leaving',
                    KIS_RETURN:'User returning',

                    POPUP_SHOWN:        'Popup shown',
                    POPUP_BUTTON_YES:   'Click: Yes',
                    POPUP_BUTTON_NO:    'Click: No',
                    POPUP_BUTTON_CLOSE: 'Click: Close',
                }
            },


            // API for the app's content
            API: {
                TIMEOUT_IN_MS:      ( envType === 'prod' ) ? 30000 : 240000,

                // Content API | http://docs.vicsquiz.apiary.io/
                CMS: {
                    PROTOCOL: 'https',

                    // API's available endpoints
                    PATHS: {
                        STUDY_AREAS:    'topic',
                        DEGREES:        'programme',
                        POSTGRAD_AREAS: 'postgrad-subject',
                        POSTGRADS:      'postgrad',
                        GRADUATE_QUALS: 'postgrad-graduate',
                        OTHER_QUALS:    'other-quals',
                        GLOBAL:         'global',
                        CATEGORIES_LISTING: 'categories',
                        COUNTRIES:      'countries',
                        COURSES:        'course-names',
                        EXCHANGE_RATES: 'exe'
                    },
                },

                // International content API | https://victoriauniversity.atlassian.net/wiki/display/IO/RightNow+operations+instigated+by+calls+to+Tools+WS
                INTERNATIONAL: {
                    BASE_URL: urls.international + '/international/1.2/action/',

                    PARAMS: {
                        PROGRAMME: {
                            'service':          "programme",
                            'action':           "get",
                            'displayProcessing':"true"
                        }
                    }
                },

                WEB_SEARCH: {
                    BASE_URL: urls.website + '/search' // Might be redundant with URLS.VICTORIA_SEARCH
                }
            },

            UI: {
                ANIMATIONS: {
                    SLIDE_UP_IN_MS:   200,
                    SLIDE_DOWN_IN_MS: 500
                },
                RESPONSIVE: {
                    MOBILE_LARGE_WIDTH: 759,
                    MOBILE_WIDTH:       499
                },
                PATHS: {
                    IMAGES: {
                        BANNER_DEFAULT: 'assets/img/banner-default.jpg',
                        KIS_SQUARE:     'assets/img/kis-button-square.jpg',
                        KIS_LANDSCAPE:  'assets/img/kis-button-landscape.jpg'
                    }
                }
            }
        };


        // Turn Object's attributes into constants!
        Object.freeze( config );

        return config;
    };
})();
